import React from 'react'
import ariya_banner from '../images/ariya_banner.jpeg'

const Catering = () => {




    return (
        <>
        <div className="vendor_card">
            <div className="vendor_card_package">
                Standard
                    </div>
            <div className="vendor_card_name">
                <h4>VixPlus Catering Services </h4>
            </div>
            <div className="vendor_card_category">
                <p> Catering Services</p>
            </div>
            <div className="vendor_card_logo">
                <img src={ariya_banner} alt="" />
            </div>
            <div className="vendor_card_footer">
                <div>
                    <h5> N750,000</h5>
                </div>
                <div>
                    <button>View Profile</button>
                </div>
            </div>
        </div>
        <div className="vendor_card">
            <div className="vendor_card_package2">
                Economy
                    </div>
            <div className="vendor_card_name">
                <h4>Cakes N Cream</h4>
            </div>
            <div className="vendor_card_category">
                <p> Wedding Cake</p>
            </div>
            <div className="vendor_card_logo">
                <img src={ariya_banner} alt="" />
            </div>
            <div className="vendor_card_footer">
                <div>
                    <h5> N50,000</h5>
                </div>
                <div>
                    <button>View Profile</button>
                </div>
            </div>
        </div>
        <div className="vendor_card">
            <div className="vendor_card_package">
                Standard
                    </div>
            <div className="vendor_card_name">
                <h4>Divine Grace</h4>
            </div>
            <div className="vendor_card_category">
                <p> Event Center</p>
            </div>
            <div className="vendor_card_logo">
                <img src={ariya_banner} alt="" />
            </div>
            <div className="vendor_card_footer">
                <div>
                    <h5> N1,000,000</h5>
                </div>
                <div>
                    <button>View Profile</button>
                </div>
            </div>
        </div>
    </>
    )
}

export default Catering
